import React, { Component } from "react";
import Navigate from "../../../shared/navigation/navigate";
import { routesContext } from "../../../shared/routes/routes-context";

export default class MyCoursesButton extends Component {
  static contextType = routesContext;
  goToPage = () => Navigate.toPath(this.context.myCoursesSelectCourse.path);
  render() {
    return (
      <div className="accordion-item">
        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
        <div
          className="accordion-item__head border-focus my-courses-button"
          onClick={this.goToPage}
          tabIndex="0"
          role="button"
        >
          <div className="p-row">
            <div className="l-col">
              <span className="accordion-item__label">My Courses</span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
